module.exports = "/_next/static/images/9f9ae83a6761a611ac83ba466f4e1ac6-moradita-icon.svg";